<div class="container">
  <div class="main-div">
    <div class="center-pane">
      <div class="form-div">
        <div class="header">
          <div class="logo">
            <img src="assets/logo-full.svg"/>
          </div>
          <h2 i18n="@@merchantCreateNewPasswordTitle">Create New Password</h2>
          <p i18n="@@merchantCreateNewPasswordSubtitle">For your security, please change your password.</p>
        </div>
        <!-- password -->
        <input-text-field (onchange)="updateInputFieldById('password', $event)"
                          [errorHandling]="errorHandling"
                          [floatingLabel]="passwordLabel"
                          [group]="form"
                          [id]="'password'"
                          [inputType]=InputType.password
                          [validators]=[Validators.required,Validators.minLength(8),Validators.maxLength(64),validatePassword]
        ></input-text-field>
        <!-- confirm PasswordItem -->
        <input-text-field (onchange)="updateInputFieldById('confirmPassword', $event)"
                          [errorHandling]="errorHandling"
                          [floatingLabel]="confirmPasswordLabel"
                          [group]="form"
                          [id]="'confirmPassword'"
                          [inputType]=InputType.password
                          [validators]=[Validators.required]
        ></input-text-field>

        <div *ngIf="serverError?.hasActualValue()"
             class="alert alert-danger form-alert">{{ serverError }}</div>

        <primary-button
          (onClick)="onUpdateSubmitted()"
          [loading]="isLoading"
          [title]="loginLabel">
        </primary-button>
      </div>
    </div>
  </div>
</div>
